var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"name":_vm.name,"label":_vm.label,"help-text":_vm.helpText,"error":_vm.error,"label-width":_vm.labelWidth,"input-width":_vm.inputWidth}},[_c('gallery-widget',{attrs:{"value":_vm.value,"nullable":_vm.nullable},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }